export default __webpack_public_path__ + "static/media/cnbcLogo.37fa5b1c.svg";